import React from 'react';

type TTopSectionWithNoImageryProps = {
  title: string;
};

const TopSectionWithNoImagery = ({ title }: TTopSectionWithNoImageryProps) => (
  <div className="seller-header__with-no-imagery-top-section">
    <h2 className="title">{title}</h2>
  </div>
);

export default TopSectionWithNoImagery;
